// extracted by mini-css-extract-plugin
export default {"main_join_page_home":"JoinPageHome_main_join_page_home__kimdM"};